export default __webpack_public_path__ + "static/media/question_17.a606fbb3.png";